import moment from 'moment';

import { stringNullable } from 'common/types/stringNullable';

const getLocale = () => window.localStorage.getItem('i18nextLng') || 'en';

export const displayDate = (
  date: stringNullable | Date,
  format = 'DD.MM.YYYY.',
  placeholder = '-',
) => (!!date ? moment(date).locale(getLocale()).format(format) : placeholder);

export const displayDateTime = (
  date: stringNullable | Date,
  format = 'DD.MM.YYYY. HH:mm',
  placeholder = '-',
) => displayDate(date, format, placeholder);

export const displayInterval = (
  from: stringNullable | Date,
  to: stringNullable | Date,
  format = 'MMM DD, YYYY',
) => `${displayDate(from, format, '')} - ${displayDate(to, format, '')}`;

export const sortByDateTime = (
  a: stringNullable | Date,
  b: stringNullable | Date,
  inputFormat = 'DD.MM.YYYY. HH:mm:ss',
) => moment(a, inputFormat).diff(moment(b, inputFormat));

export const dateWithoutTime = (date: stringNullable | Date, placeholder = '-') =>
  !!date ? moment(date, 'DD.MM.YYYY. HH:mm:ss').format('DD.MM.YYYY.') : placeholder;

export const timeWithoutDate = (date: stringNullable | Date) => moment(date).format('HH:mm');
